import React from 'react'
import { DataSet } from '../models/types'
export const DataSetContext = React.createContext<{
  loading: boolean
  dataSets: DataSet[]
}>({
  loading: true,
  dataSets: []
})
